import React from "react";
import { Button, Whisper, Tooltip } from "rsuite";
import logger from "../../utils/logger";
import "./button.css";

function BestStartButton({ text, content, color = "blue", width = 100, height = 50, onClick = () => { logger.warn('no click handler attached!') }, className = '', appearance = 'primary', "data-testid": dataTestId, tooltip, ...props }) {
  const isIconOnly = !text || React.isValidElement(text);
  const finalHeight = isIconOnly ? width : height;
  const WrapperComponent = tooltip ? Whisper : React.Fragment;
  const wrapperProps = tooltip ? { placement: "top", trigger: "hover", speaker: <Tooltip>{tooltip}</Tooltip> } : {};

  const button = (
    <Button data-testid={`${dataTestId}-container`} className={`best-start-button best-start-button-${color} ${isIconOnly ? 'best-start-button-icon' : ''} ${className}`} style={{ width: width, height: finalHeight }} appearance={appearance} onClick={onClick} {...props}>
      <span data-testid={dataTestId} className="best-start-button-content">
        {content}{text}
      </span>
    </Button>
  );

  return (
    <WrapperComponent {...wrapperProps}>
    {tooltip ? <span style={{ display: 'inline-flex' }}>{button}</span> : button}
    </WrapperComponent>
  );
}

export default BestStartButton;
